import { render } from "./newVerifySlide.vue?vue&type=template&id=2922c4aa"
import script from "./newVerifySlide.vue?vue&type=script&lang=js"
export * from "./newVerifySlide.vue?vue&type=script&lang=js"

import exportComponent from "/data/soft/jenkins/workspace/S09_ehm-acsecurity-pro-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__